<template>
  <div class="village-arch">
    <h3 class="village-arch__title">{{ architecture.title }}</h3>

    <div class="village-arch__apps">
      <div
        v-for="app in architecture.applications"
        :key="app.title"
        class="village-arch__app-col"
      >
        <h4>{{ app.title }}</h4>
        <div class="village-arch__app-items">
          <span v-for="item in app.items" :key="item">{{ item }}</span>
        </div>
      </div>
    </div>

    <div class="village-arch__middle">
      <div class="village-arch__middle-block">
        <h4 class="village-arch__middle-title">2个数据库</h4>
        <div class="village-arch__databases">
          <div
            v-for="db in architecture.dataLayer.databases"
            :key="db.title"
            class="village-arch__database"
          >
            <h5>{{ db.title }}</h5>
            <div class="village-arch__db-items">
              <span v-for="item in db.items" :key="item">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="village-arch__middle-block">
        <h4 class="village-arch__middle-title">3个平台</h4>
        <div class="village-arch__platforms">
          <span
            v-for="platform in architecture.dataLayer.platforms"
            :key="platform"
            class="village-arch__platform"
          >{{ platform }}</span>
        </div>
      </div>
    </div>

    <div class="village-arch__arrow" aria-hidden="true">↑</div>

    <div class="village-arch__sources">
      <div
        v-for="source in architecture.sources"
        :key="source.title"
        class="village-arch__source"
      >
        <h4>{{ source.title }}</h4>
        <div class="village-arch__source-items">
          <span v-for="item in source.items" :key="item">{{ item }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'VillageArchDiagram',
  props: {
    architecture: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.village-arch {
  max-width: 1200px;
  margin: 0 auto;
  border: 1px solid #c8e6d9;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.village-arch__title {
  margin: 0;
  padding: 18px 24px;
  font-size: 22px;
  font-weight: 700;
  color: var(--theme-primary, #0a6e4e);
  text-align: center;
  border-bottom: 1px solid #c8e6d9;
}

.village-arch__apps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  border-bottom: 1px solid #c8e6d9;
}

.village-arch__app-col h4 {
  margin: 0;
  padding: 12px 8px;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  background: var(--theme-primary, #0a6e4e);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.village-arch__app-col:last-child h4 {
  border-right: none;
}

.village-arch__app-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 12px 10px;
  background: #f4fbf7;
  min-height: 160px;
  border-right: 1px solid #e0f0e8;
}

.village-arch__app-col:last-child .village-arch__app-items {
  border-right: none;
}

.village-arch__app-items span {
  background: #fff;
  border: 1px solid #b8dfc8;
  color: #2e6b52;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 8px 4px;
  line-height: 1.35;
  border-radius: 2px;
}

.village-arch__middle {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 0;
  border-bottom: 1px solid #c8e6d9;
  background: #eef8f2;
}

.village-arch__middle-block {
  padding: 16px;
}

.village-arch__middle-block + .village-arch__middle-block {
  border-left: 1px solid #c8e6d9;
}

.village-arch__middle-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: var(--theme-primary, #0a6e4e);
  text-align: center;
}

.village-arch__databases {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.village-arch__database {
  background: #fff;
  border: 1px solid #b8dfc8;
  border-radius: 4px;
  padding: 12px 10px;
  text-align: center;
}

.village-arch__database h5 {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 700;
  color: var(--theme-primary, #0a6e4e);
}

.village-arch__db-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

.village-arch__db-items span {
  font-size: 12px;
  color: #444;
  padding: 4px 8px;
  background: #f4fbf7;
  border: 1px solid #d4eadc;
  border-radius: 2px;
}

.village-arch__platforms {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  min-height: calc(100% - 32px);
}

.village-arch__platform {
  background: #fff;
  border: 1px solid #b8dfc8;
  color: #2e6b52;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  padding: 12px 10px;
  border-radius: 4px;
  line-height: 1.4;
}

.village-arch__arrow {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: var(--theme-primary, #0a6e4e);
  padding: 6px 0;
  background: #fff;
  border-bottom: 1px solid #c8e6d9;
}

.village-arch__sources {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  background: #f4fbf7;
}

.village-arch__source {
  padding: 16px 14px;
  text-align: center;
  border-right: 1px solid #c8e6d9;
}

.village-arch__source:last-child {
  border-right: none;
}

.village-arch__source h4 {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 700;
  color: var(--theme-primary, #0a6e4e);
}

.village-arch__source-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.village-arch__source-items span {
  font-size: 12px;
  color: #444;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #d4eadc;
  border-radius: 2px;
}

@media (max-width: 960px) {
  .village-arch__apps {
    grid-template-columns: repeat(2, 1fr);
  }

  .village-arch__app-col:nth-child(2) h4,
  .village-arch__app-col:nth-child(2) .village-arch__app-items {
    border-right: none;
  }

  .village-arch__middle {
    grid-template-columns: 1fr;
  }

  .village-arch__middle-block + .village-arch__middle-block {
    border-left: none;
    border-top: 1px solid #c8e6d9;
  }

  .village-arch__sources {
    grid-template-columns: 1fr;
  }

  .village-arch__source {
    border-right: none;
    border-bottom: 1px solid #c8e6d9;
  }

  .village-arch__source:last-child {
    border-bottom: none;
  }
}

@media (max-width: 560px) {
  .village-arch__apps {
    grid-template-columns: 1fr;
  }

  .village-arch__app-col h4,
  .village-arch__app-items {
    border-right: none !important;
  }

  .village-arch__databases {
    grid-template-columns: 1fr;
  }
}
</style>
